import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { Queue } from '../types/interfaces/queue.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QueueService {
  private http = inject(HttpClient);


  getQueue(id: number){
    return this.http.get<Queue>(`${environment.apiHost}/queue/${id}`, {
      withCredentials: true,
    });
  }

  getQueues(){
    return this.http.get<Queue[]>(`${environment.apiHost}/queue`, {
      withCredentials: true,
    });
  }

  createQueue(queue: Queue): Observable<Queue> {
    return this.http.post<Queue>(`${environment.apiHost}/queue`, queue, {
      withCredentials: true,
    });
  }

  updateQueue(queue: Queue): Observable<Queue> {
    return this.http.put<Queue>(
      `${environment.apiHost}/queue/${queue.id}`,
      queue,
      {
        withCredentials: true,
      }
    );
  }

  deleteQueue(id: number): Observable<Queue> {
    return this.http.delete<Queue>(`${environment.apiHost}/queue/${id}`, {
      withCredentials: true,
    });
  }
}
